import { JsonProperty, JsonObject } from 'json2typescript';
import { ModelObject } from '@hermes/api-model-core';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Represents location coordinate
 *
 * @dynamic
 */
let Coordinates = class Coordinates extends ModelObject {
    constructor(source) {
        super();
        Object.assign(this, source);
    }
};
__decorate([
    JsonProperty("latitude"),
    __metadata("design:type", Number)
], Coordinates.prototype, "latitude", void 0);
__decorate([
    JsonProperty("longitude"),
    __metadata("design:type", Number)
], Coordinates.prototype, "longitude", void 0);
Coordinates = __decorate([
    JsonObject("Coordinates"),
    __metadata("design:paramtypes", [Object])
], Coordinates);

/**
 * class used to describe a Locale
 * Locale is a tuple of a country code and a language
 *
 * @deprecated Use locale object from `@hermes/shared` instead
 */
class Locale extends ModelObject {
    constructor(country, language) {
        super();
        this.language = language;
        this.countryCode = country;
    }
    /**
     * @returns return a Locale Object
     * @param code {string} a code on format country_language or language_country
     * @param isCountryFirst boolean to indicate wich information is in first
     */
    static createFromCode(code, isCountryFirst = true) {
        if (!code) {
            throw new Error(`Given string (${code}) is not compatible [Country code]_[Language code] or [Country code]/[Language code] or [Country code]-[Language code]`);
        }
        const splittedString = code.split(/[/_-]/);
        // Case 1 : Only one element provided
        if (!splittedString[1]) {
            return new Locale(splittedString[0], splittedString[0]);
        }
        // Case 2 : Language_CountryCode Provided ==> Angular Mode
        if (!isCountryFirst) {
            return new Locale(splittedString[1], splittedString[0]);
        }
        // Standard case : CountryCode_Language ==> CMS Mode
        return new Locale(splittedString[0], splittedString[1]);
    }
    /**
     * @returns locale informations for CMS and magento use
     */
    getLocaleCode() {
        return `${this.countryCode}_${this.language}`;
    }
    /**
     * @returns locale informations for i18n
     */
    getI18nLocaleCode() {
        return `${this.language}-${this.countryCode.toUpperCase()}`;
    }
    /**
     * @returns locale informations for Angular use
     */
    getAngularLocaleCode() {
        switch (this.countryCode) {
            case "fr":
            case "es":
            case "de":
                return this.countryCode;
            case "us":
                return this.language;
            case "no":
                return `${this.language === "no" ? "nb" : this.language}-nb`;
            case "uk":
                return `${this.language}-gb`;
            case "jp":
                return "ja";
            default:
                return `${this.language}-${this.countryCode}`;
        }
    }
    /**
     * @returns locale informations URL use
     */
    getLocaleUrl() {
        if (this.countryCode && this.language) {
            return `/${this.countryCode.toLowerCase()}/${this.language.toLowerCase()}`;
        }
        throw new Error("language or countryCode undefined !");
    }
    /**
     * @returns language
     */
    getLanguage() {
        return this.language;
    }
    /**
     * @returns current country code
     */
    getCountryCode() {
        return this.countryCode;
    }
}

export { Coordinates, Locale };
